module.exports = __webpack_public_path__ + "static/media/First_Gousto_Box_Free.0036933f.svg";